export const getScrollElementId = state => state.pageScroller
